import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import ColorIcon from '@src/components/ColorIcon/ColorIcon';
import {HexColor} from '@src/@types/colors';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';

export default class ColorPickerColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn, Model> {
    render() {
        return <ColorIcon color={this.value as (HexColor | null)}/>;
    }
}
